import { Image } from '@chakra-ui/react'
import React from 'react'
import { getIconByName } from '../utils/iconUtils'
import { ChatGlyph } from './ChatInterface/ChatGlyph'

// An agent's picture: a named icon, an image URL, or a fallback glyph (a bot
// for library agents, the chat glyph otherwise).
export const getAgentIcon = (picture: string | null | undefined, size: number, isLibraryAgent = false) => {
  const fallback = (isLibraryAgent && getIconByName('Bot', size)) || <ChatGlyph name='chat' size={size} />
  const namedIcon = getIconByName(picture ?? null, size)
  if (namedIcon) return namedIcon
  if (picture && /^(https?:\/\/|\/)/.test(picture)) {
    return (
      <Image src={picture} alt='' boxSize={`${size}px`} objectFit='contain' borderRadius='3px' fallback={fallback} />
    )
  }
  return fallback
}
